<template>
  <div
    v-loading="loading"
    class="l-page l-page--search"
  >
    <div class="l-page__header c-page__header">
      <h2
        v-menu-title
        class="c-page__header-title"
      >
        维保计划管理
      </h2>
      <div class="c-page__header-btns">
        <k-button
          type="primary"
          icon="kestrel-icon ki-search"
          btn-text="查询"
          @click="refreshSearch"
        />
        <k-button
          icon="kestrel-icon ki-repeat"
          btn-text="重置"
          @click="resetForm"
        />
      </div>
    </div>
    <div class="l-page__item l-page--search__item">
      <hm-page-card
        title="查询条件"
        class="c-card--condition"
      >
        <el-form
          ref="filterParams"
          class="c-form c-condition__form"
          :model="filterParams"
          :inline="true"
          label-position="right"
          label-width="80px"
          label-suffix="："
        >
          <el-row class="c-form__row">
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="项目名称"
              >
                <el-input
                  v-model.trim="filterParams.xmmc"
                  class="c-form__input"
                  placeholder="请输入项目名称"
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </hm-page-card>
    </div>
    <div class="l-page__body l-page--search__body">
      <el-tabs
        type="border-card"
        class="l-page__tabs l-page__tabs--single"
      >
        <el-tab-pane label="查询结果">
          <k-table
            ref="kTable"
            height="100%"
            :table-column="tableColumn"
            :data="page.rows"
            :pagination="page"
            @current-change="search"
            @size-change="handleSizeChange"
          >
            <template #xmmc="scope">
              <el-link
                type="primary"
                @click="openProjectPlans(scope.row)"
              >
                {{ scope.row.xmmc }}
              </el-link>
            </template>
          </k-table>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { planService } from './plan.service';

export default {
  name: 'JxxfWbPlanIndex',
  data () {
    return {
      loading: false,
      filterParams: { xmmc: null },
      trueFilterParams: {},
      page: { rows: [], total: 0, pageSize: 15, pageNo: 0 },
      tableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'xmmc', slotName: 'xmmc', label: '项目名称', align: 'left', minWidth: '180', type: 'text' },
        { key: 'htyxqQ', label: '合同有效期起', align: 'center', minWidth: '110', type: 'date' },
        { key: 'htyxqZ', label: '合同有效期止', align: 'center', minWidth: '110', type: 'date' },
        { key: 'jhzs', label: '计划总数', align: 'right', minWidth: '85', type: 'text' },
        { key: 'wkss', label: '未开始数', align: 'right', minWidth: '85', type: 'text' },
        { key: 'zxz', label: '执行中', align: 'right', minWidth: '75', type: 'text' },
        { key: 'dscbg', label: '待生成报告', align: 'right', minWidth: '100', type: 'text' },
        { key: 'dgz', label: '待盖章', align: 'right', minWidth: '75', type: 'text' },
        { key: 'ywc', label: '已完成', align: 'right', minWidth: '75', type: 'text' },
        { key: 'wcbfb', label: '完成百分比', align: 'right', minWidth: '95', type: 'text' }
      ]
    };
  },
  methods: {
    /** 保存查询条件并从第一页加载项目计划汇总。 */
    refreshSearch () {
      this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
      this.search(1);
    },
    /** 使用当前分页参数加载项目计划汇总。 */
    search (pageNo = 1) {
      this.loading = true;
      planService.projectPage(Object.assign({}, this.trueFilterParams, { pageNo, pageSize: this.page.pageSize })).then(rsp => {
        this.page = Object.assign({}, this.page, rsp.data);
      }).finally(() => {
        this.loading = false;
      });
    },
    /** 使用统一表格组件的页大小重新查询。 */
    handleSizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.search(1);
    },
    /** 清空项目计划汇总查询条件。 */
    resetForm () {
      this.$refs.filterParams.resetFields();
    },
    /** 打开指定维保项目的计划明细页面。 */
    openProjectPlans (row) {
      this.openNavTab({ name: 'jxxfWbPlanProjectList', params: { xmId: row.xmId } });
    }
  },
  created () {
    this.refreshSearch();
  }
};
</script>
